import { useSetDocumentTitle } from 'hooks/useSetDocumentTitle';
import { searchFacetsOrg } from 'modules/search/constants/searchFacetsOrg';
import { SearchPage } from 'modules/search/pages/Search/SearchPage';

export function SearchOrgsPage() {
  useSetDocumentTitle(
    /* TRANSLATORS: org search page title */
    getText(
      'Directory of Nonprofits, Government Agencies, Social Impact Companies',
    ),
  );

  return (
    <SearchPage
      searchType="ORG"
      searchFacets={searchFacetsOrg}
      allowAds={false}
    />
  );
}
